// extracted by mini-css-extract-plugin
module.exports = {"sectionDetail":"DetailOrder-Jtails_sectionDetail_Hf9gn","isStyleDingBeauty":"DetailOrder-Jtails_isStyleDingBeauty_22ZUD","container":"DetailOrder-Jtails_container_1zI0b"};